import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=6bf355e6&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=6bf355e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf355e6",
  null
  
)

export default component.exports